export const brokerConvenienceCryptoTestTags = (eventTag = null) => ({
    startTest: {
        action: "click",
        format: "button",
        component: "body",
        element: "startTest",
        pathname: eventTag && eventTag.pathname,
    },

    cancelButton: {
        action: "cancel",
        format: "link",
        component: "lowerNavigation",
        element: "cancel"
    },

    selectOption: {
        action: "select",
        format: "radiobutton",
        component:  eventTag && eventTag.component,
        element: eventTag && eventTag.element,
    },

    backButton: {
        action: "return",
        format: "button",
        component: "lowerNavigation",
        element: "back",
        pathname: eventTag && eventTag.pathname,
    },

    nextButton:{
        action: "continue",
        format: "button",
        component: "lowerNavigation",
        element: "continue",
        pathname: eventTag && eventTag.pathname,
    },

    editMode: {
        action: "edit",
        format: "icon",
        component: "navigationCard",
        element: eventTag && eventTag.element,
    },

    confirmAnswers: {
        action: "click",
        format: "button",
        component: "lowerNavigation",
        element: "confirmAnswers",
        pathname: eventTag && eventTag.pathname,
    },

    modalResultApprovedOpen: {
        action: "open",
        format: "modal",
        component: "modal/understandCryptocurrencyInvestment",
        element: "full"
    },

    modalResultApprovedContinue: {
        action: "click",
        format: "button",
        component: "modal/understandCryptocurrencyInvestment",
        element: "continue"
    },

    modalResultApprovedClose: {
        action: "close",
        format: "cross",
        component: "modal/understandCryptocurrencyInvestment",
        element: "close"
    },

    modalResultDissaprovedOpen: {
        action: "open",
        format: "modal",
        component: "modal/notUnderstandCryptocurrencyInvestment",
        element: "full"
    },

    modalResultDissaprovedContinue: {
        action: "click",
        format: "button",
        component: "modal/notUnderstandCryptocurrencyInvestment",
        element: "continue"
    },

    modalResultDissaprovedClose: {
        action: "close",
        format: "cross",
        component: "modal/notUnderstandCryptocurrencyInvestment",
        element: "close"
    },

    readDocumentation: {
        action: "click",
        format: "button",
        component: "lowerNavigation",
        element: "readDocumentation",
        pathname: eventTag && eventTag.pathname,
    },

    modalDocumentationClose: {
        action: "close",
        format: "cross",
        component: "header",
        element: "cross"
    },

    modalDocumentationPrint: {
        action: "click",
        format: "button",
        component: "quickButton",
        element: "print"
    },

    modalDocumentationDownload: {
        action: "download",
        format: "button",
        component: "quickButton",
        element: "download"
    },

    modalDocumentationSign: {
        action: "click",
        format: "button",
        component: "lowerNavigation",
        element: "signDocumentation"
    }
});